/** Saves Unmasked Customer Info
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customersunmaskedInformation
*/
export const SAVE_CUSTOMER_INFO = (state, payload) => {
    state.profileUnmaskedInfo = payload
}

/** Saves Accounts Balances
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCES = (state, payload) => {
    state.accountsBalances = payload.balanceViews
}

/** Saves Account Plafond
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransfersplafondaccount%7BaccountId%7D
*/
export const SAVE_ACCOUNT_PLAFOND = (state, payload) => {
    state.customerPlafonds = payload
}

/** Saves Customers Limits
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransferscustomerlimits
*/
export const SAVE_CUSTOMER_LIMITS = (state, payload) => {
    state.customerLimits = payload
}

/** Saves Currencies List
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransferscurrencies
*/
export const SAVE_TRANSFER_CURRENCIES = (state, payload) => {
    state.currenciesList = payload
}

/** Saves Countries List
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransferscountries
*/
export const SAVE_COUNTRIES_LIST = (state, payload) => {
    state.countriesList = payload
}

/** Saves Transfer Reasons List
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransfersreasons
*/
export const SAVE_TRANSFER_REASONS = (state, payload) => {
    state.transfersReasons = payload
}

/** Saves Operation types List depending on reason selected
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransfersreasons
*/
export const SAVE_TRANSFER_OOPERATIONS_TYPES = (state, payload) => {
    state.operationTypesList = payload || []
}

/** Saves Categories List depending on operation type selected
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransfersreasons
*/
export const SAVE_TRANSFER_CATEGORIES = (state, payload) => {
    state.categoriesList = payload || []
}

/** Saves Payments types List depending on operation category
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransfersreasons
*/
export const SAVE_TRANSFER_PAYMENT_TYPES = (state, payload) => {
    state.paymentTypesList = payload || []
}

/** Saves Transfer Expenses
@payload { Array }
*/
export const SAVE_TRANSFER_EXPENSES = (state, payload) => {
    state.transfersExpenses = payload
}

/** Saves International Transfers Requests List
@payload { Object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransfers
*/
export const SAVE_TRANSFERS_LIST = (state, { pageNumber, data }) => {
    state.transfersRequestsList = pageNumber === 1 ? data.internationalTransferProcesses : state.transfersRequestsList.concat(data.internationalTransferProcesses)

	state.transfersRequestsListHasMore = data.hasMore
}

/** saves Favorites List
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_favoriteslist
*/
export const SAVE_FAVORITES = (state, { pageNumber, data }) => {
    state.favoritesList = pageNumber === 1 ? data.favorites : state.favoritesList.concat(data.favorites)

    state.favoritesHasMore = state.favoritesList.length < data.total
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.accountsBalances = []
    state.customerLimits = []
    state.customerPlafonds = []
    state.transfersReasons = []
    state.operationTypesList = []
    state.categoriesList = []
    state.paymentTypesList = []
    state.transfersExpenses = []
    state.currenciesList = []
    state.profileUnmaskedInfo = []
    state.countriesList = []
    state.transfersRequestsList = []
    state.favoritesList = []
}
